/**
 * CaseSummaryStats.tsx
 * 
 * Summary statistics dashboard for FI Investigation page
 * Shows counts of open, investigating, resolved cases
 */

import { FC } from 'react';
import { FiAlertCircle, FiEye, FiCheckCircle, FiClock } from 'react-icons/fi';

interface CaseSummaryStatsProps {
  totalCases: number;
  openCount: number;
  investigatingCount: number;
  resolvedCount: number;
}

const CaseSummaryStats: FC<CaseSummaryStatsProps> = ({
  totalCases,
  openCount,
  investigatingCount,
  resolvedCount
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h3 className="text-lg font-semibold text-slate-700 mb-4">Case Summary</h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Total Cases */}
        <div className="bg-slate-50 rounded-lg p-4 border border-slate-200">
          <div className="flex items-center justify-between mb-2">
            <div className="text-sm font-medium text-slate-600">Total Cases</div>
            <FiClock className="text-slate-400" size={20} />
          </div>
          <div className="text-3xl font-bold text-slate-800">{totalCases}</div>
        </div>

        {/* Open Cases */}
        <div className="bg-orange-50 rounded-lg p-4 border border-orange-200">
          <div className="flex items-center justify-between mb-2">
            <div className="text-sm font-medium text-orange-700">Open</div>
            <FiAlertCircle className="text-orange-500" size={20} />
          </div>
          <div className="text-3xl font-bold text-orange-600">{openCount}</div>
        </div>

        {/* Investigating Cases */}
        <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
          <div className="flex items-center justify-between mb-2">
            <div className="text-sm font-medium text-blue-700">Investigating</div>
            <FiEye className="text-blue-500" size={20} />
          </div>
          <div className="text-3xl font-bold text-blue-600">{investigatingCount}</div>
        </div>

        {/* Resolved Cases */}
        <div className="bg-green-50 rounded-lg p-4 border border-green-200">
          <div className="flex items-center justify-between mb-2">
            <div className="text-sm font-medium text-green-700">Resolved</div>
            <FiCheckCircle className="text-green-500" size={20} />
          </div>
          <div className="text-3xl font-bold text-green-600">{resolvedCount}</div>
        </div>
      </div>
    </div>
  );
};

export default CaseSummaryStats;
